import { render, staticRenderFns } from "./ErrorNotification.vue?vue&type=template&id=565ff5df&"
import script from "./ErrorNotification.vue?vue&type=script&lang=js&"
export * from "./ErrorNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports